import { createFileRoute, redirect } from '@tanstack/react-router'
import { hasFeature } from '@/lib/features'
import { WorkspaceGenerationSettings } from '@/features/workspaces/settings'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/settings/brand'
)({
  // Pins a model and prompt per vertical, so with none on the plan there is
  // nothing to configure.
  beforeLoad: ({ context, params }) => {
    const { features } = context.entitlements
    if (!hasFeature(features, 'image') && !hasFeature(features, 'video')) {
      throw redirect({
        to: '/org/$orgId/workspace/$workspaceId/settings/general',
        params,
        replace: true,
      })
    }
  },
  component: BrandSettingsPage,
})

function BrandSettingsPage() {
  const { orgId, workspaceId } = Route.useParams()
  return <WorkspaceGenerationSettings orgId={orgId} workspaceId={workspaceId} />
}
